import { SvgIcon, SxProps } from "@mui/material";
import IconSvg from "jsx:../../../Images/Icons/FontAwesome/solid/right.svg";

export function RightIcon(props: SxProps) {
    return <SvgIcon component={IconSvg} inheritViewBox sx={props} />;
}
